import { useMemo } from 'react';
import { useDocumentSnapshot } from '../../../../../firebase/firestore/hooks';
import { Collections } from '../../../../../firebase/firestore/collections';
import { Candidate } from '../../../../../firebase/firestore/documents/candidate';
import { Position } from '../../../../../firebase/firestore/documents/position';
import DocumentUploadQuestionsPresenter from '../documentUploadQuestions/documentUploadQuestionsPresenter';
import { QuestionStateEnum } from './useVideoResponseQuestions';

export type DocumentQuestionState = {
  state: QuestionStateEnum;
  questions?: DocumentUploadQuestionsPresenter;
  initialized: boolean;
};

const useDocumentUploadQuestions = (candidate?: Candidate, positionId?: string): DocumentQuestionState => {
  const position = useDocumentSnapshot<Position>(Collections.POSITIONS, (candidate?.position ?? positionId) || '');

  return useMemo(() => {
    // 1. Loading state (position not ready)
    if (!position) {
      return {
        state: QuestionStateEnum.LOADING,
        questions: undefined,
        initialized: false,
      };
    }

    const documentResponses = candidate?.documentUploadQuestionResponses ?? [];

    // 2. UNDEFINED state (no responses + not applicable)
    const isUndefined =
      candidate && !documentResponses.length && (candidate.monetized || !position?.documentUploadQuestions?.length);

    if (isUndefined) {
      return {
        state: QuestionStateEnum.UNDEFINED,
        questions: undefined,
        initialized: true,
      };
    }

    // 3. READY state
    const presenter = new DocumentUploadQuestionsPresenter(position, candidate);
    return {
      state: QuestionStateEnum.READY,
      questions: presenter,
      initialized: true,
    };
  }, [candidate, position]);
};

export default useDocumentUploadQuestions;
